import {useIntl} from 'react-intl';
import {useMemo} from 'react';


import * as dataUtils from '../../../../utils/dataUtils';

import useContentDepartments from './useContentDepartments';


/**
 * Returns translated and sorted content departments
 */
function useContentDepartmentsI18n() {

    const {formatMessage, locale, messages} = useIntl();
    const contentDepartments = useContentDepartments();

    // memo to not sort unnecessarily, but listen to the actual translation to not prematurely cache
    return useMemo(() => {

        const unsortedContentDepartments = [];
        contentDepartments.forEach(contentDepartment => {

            const label = formatMessage({id: `department.${contentDepartment}`});
            unsortedContentDepartments.push({
                label,
                sortLabel: label.toLowerCase(),
                value: contentDepartment
            });
        });

        return dataUtils.sortBy(unsortedContentDepartments, {sortLabel: 1});

    }, [locale, contentDepartments, messages['department.all']]);
}


export default useContentDepartmentsI18n;
